export const isAssetReadOnly = (
  account: any,
  workspaceAsset: any
): boolean => {
  if (!account || !workspaceAsset) {
    return false;
  }
  
  return (
    !account.isGlobalAdmin() && 
    !account.allowedWorkspaces?.some((w: any) => w.id === workspaceAsset.workspace?.id)
  );
};
